import { useCallback } from 'react';
import { Icon } from '../../../common/view/icon/icon';
import { MonoIcon } from '../../../common/view/icon/mono/mono-icon';
import { CssFuncs } from '../../../foundation/css/css.funcs';
import { NodeItemActionCheckStyle } from './node-item-action-check.style';

export function NodeItemActionCheck({ checked, disabled, onChange }: { checked?: boolean; disabled?: boolean; onChange?: (checked: boolean) => void }) {
  // const [isChecked, setIsChecked] = useState(checked ?? false);

  // useEffect(() => {
  //   setIsChecked(checked ?? false);
  // }, [checked]);

  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }
    // setIsChecked((prev) => !prev);
    onChange?.(!checked);
  }, [onChange, disabled]);

  return (
    <NodeItemActionCheckStyle.Container
      className={CssFuncs.className((names) => {
        names.push(checked ? 'checked' : 'not-checked');
      })}
      onClick={handleClick}
    >
      <NodeItemActionCheckStyle.Icon>
        <Icon icon={MonoIcon.check} size="12px" />
      </NodeItemActionCheckStyle.Icon>
    </NodeItemActionCheckStyle.Container>
  );
}
